import React from "react";
import Dashboard from "../Pages/Dashboard/Dashboard";

const Landing = () => {
  return <Dashboard />;
};

export default Landing;
